import { Routes } from '@angular/router';
import { AboutComponent } from 'app/features/about/about.component';
import { AnalyzeComponent } from 'app/features/analyze/analyze.component';
import { ExportComponent } from 'app/features/export/export.component';
import { FlightsCalendarComponent } from 'app/features/flights/flights-calendar/flights-calendar.component';
import { FlightsComponent } from 'app/features/flights/flights.component';
import { PreferencesComponent } from 'app/features/preferences/preferences.component';
import { SearchComponent } from 'app/features/search/search-form/search.component';
import { FlightDetailComponent } from 'app/features/flights/flight-detail/flight-detail.component';
import { SequenceDetailComponent } from 'app/features/flights/sequence-detail/sequence-detail.component';
import { BarChartComponent } from 'app/features/analyze/chart/bar-chart/bar-chart.component';
import { SearchResultComponent } from 'app/features/search/search-result/search-result.component';
import { PieChartComponent } from 'app/features/analyze/chart/pie-chart/pie-chart.component';
import { ComboChartComponent } from 'app/features/analyze/chart/combo-chart/combo-chart.component';
import { FlightListComponent } from 'app/features/flights/flight-list/flight-list.component';
import { VersionComponent } from 'app/features/about/children/version/version.component';
import { FeedbackComponent } from 'app/features/about/children/feedback/feedback.component';
import { isAuthenticated } from '@shared/guards/auth.guard';
import { RedirectComponent } from '@shared/components/redirect/redirect.component';
import { FaqComponent } from 'app/features/about/children/faq/faq.component';
import { AdminComponent } from 'app/features/admin/admin.component';
import { PieChartVariantComponent } from 'app/features/analyze/chart/pie-chart/aircraft-variant/pie-chart-variant.component';
import { CacheViewerComponent } from 'app/features/admin/cache-viewer/cache-viewer.component';
import { DisclaimerComponent } from 'app/features/about/children/disclaimer/disclaimer.component';
import { DownloadComponent } from 'app/features/export/download/download.component';
import { MapProjectionComponent } from 'app/features/export/map-projection/map-projection.component';

export const ROUTES: Routes = [
   
    { 
        path: 'redirect', 
        component: RedirectComponent 
    },
    { 
        path: 'flights', 
        component: FlightsComponent,
        canActivate: [isAuthenticated],
        children: [
            { 
                path: 'flight-table', 
                component: FlightListComponent,
                data: { breadcrumb: 'Flights' } 
            },
            { 
                path: 'flight-calendar', 
                component: FlightsCalendarComponent,
                data: { breadcrumb: 'Calendar'} 
            },
            { path: '', redirectTo: 'flight-table', pathMatch: 'full' },
        ]
    },
    { 
        path: 'sequence/:number/:seat/:originationDate', 
        component: SequenceDetailComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Sequence'}, 
    },
    { 
        path: 'sequence/:number/:year/:month/:originationDate/flight/:flightnNumber/:depAirport/:arrAirport/:flightDate', 
        component: FlightDetailComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Flight'} 
    },
    { 
        path: 'analyze', 
        component: AnalyzeComponent, 
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Analyze'},
    },
    { 
        path: 'analyze/bar-chart', 
        component: BarChartComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Time by Year'}  
    },
    { 
        path: 'analyze/pie-chart/:id', 
        component: PieChartComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Type'}  
    },
    { 
        path: 'analyze/pie-chart/variants/:index', 
        component: PieChartVariantComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Variant'}  
    },   
    { 
        path: 'analyze/line-chart', 
        component: ComboChartComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Time by Month'}  
    },
    { 
        path: 'search', 
        component: SearchComponent,
        data: { breadcrumb: 'Search'},  
        canActivate: [isAuthenticated] 
    },
    { 
        path: 'search/result', 
        component: SearchResultComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Results'} 
    },
    { 
        path: 'export', 
        component: ExportComponent,
        data: { breadcrumb: 'Export'},  
        canActivate: [isAuthenticated] 
    },
    {
        path: 'export/downloads',
        component: DownloadComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Downloads'}
    },
    {
        path: 'export/mapproj/:gLineByAircraft/:gLineSelected',
        component: MapProjectionComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Downloads'}
    },
    { 
        path: 'preferences', 
        component: PreferencesComponent,
        data: { breadcrumb: 'Settings'},  
        canActivate: [isAuthenticated] 
    },
    { 
        path: 'about', 
        component: AboutComponent,
        data: { breadcrumb: 'About'}, 
        canActivate: [isAuthenticated] 
    },
    { 
        path: 'about/version', 
        component: VersionComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Version Details'},
    },
    { 
        path: 'about/feedback', 
        component: FeedbackComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Feedback'},
    },
    { 
        path: 'about/disclaimer', 
        component: DisclaimerComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Disclaimer'}, 
    },
    { 
        path: 'about/faq/:path', 
        component: FaqComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'FAQ'},
    },
    { 
        path: 'admin', 
        component: AdminComponent,
        data: { breadcrumb: 'Admin'}, 
        canActivate: [isAuthenticated] 
    },
    { 
        path: 'admin/cache-viewer/:id', 
        component: CacheViewerComponent,
        canActivate: [isAuthenticated],
        data: { breadcrumb: 'Cache'}, 
    },
    { 
        path: '', 
        redirectTo: 'flights', 
        pathMatch: 'full' },
    { 
        path: '**', 
        redirectTo: 'flights' 
    },
];
  